const oaiq = (...args) => {
  if (typeof window !== 'undefined' && window.oaiq) window.oaiq(...args);
};

let lastTrackedPath = null;

// page_viewed: una sola vez por ruta (protege contra StrictMode/renders dobles)
export const trackOaiqPageView = (path) => {
  if (path === lastTrackedPath) return;
  lastTrackedPath = path;
  oaiq('measure', 'page_viewed', {
    type: 'contents',
    contents: [{ id: path, name: document.title || path, content_type: 'page' }],
  });
};

// Conversión principal: cita confirmada. Dedup por event_id persistido en localStorage.
export const trackAppointmentScheduled = (eventId) => {
  const key = 'oaiq_appt_tracked';
  const id = eventId || `appt_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  const stored = localStorage.getItem(key);
  if (stored) return; // ya registrada esta cita (recargas / thank-you tras el widget)
  oaiq('measure', 'appointment_scheduled', { type: 'customer_action' }, { event_id: id });
  localStorage.setItem(key, id);
};

// Limpia el guard al iniciar un nuevo intento de agendado (nueva visita a /agenda)
export const resetAppointmentGuardIfStale = () => {
  // Mantiene el guard 24h para cubrir recargas del thank-you; luego permite nuevas citas
  const key = 'oaiq_appt_tracked_at';
  const at = Number(localStorage.getItem(key) || 0);
  if (at && Date.now() - at > 24 * 60 * 60 * 1000) {
    localStorage.removeItem('oaiq_appt_tracked');
    localStorage.removeItem(key);
  }
  if (localStorage.getItem('oaiq_appt_tracked') && !at) {
    localStorage.setItem(key, String(Date.now()));
  }
};
